import { forPhoneOnly } from 'src/config/mediaQueries'
import { createUseStyles } from 'react-jss'

const BODY_WIDTH = 343

export default createUseStyles({
  body: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: BODY_WIDTH,
    margin: '0 auto',
    [forPhoneOnly]: {
      padding: [0, 16, 16, 16],
    },
  },
})
